package dk.rheasoft.csaware.api.aiqueries

import kotlinx.datetime.LocalDate
import kotlinx.serialization.Serializable

@Serializable
data class DailySummary(val day: LocalDate, val text: String) {
}